import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CampanaVentaComponent } from './campana-venta.component';
import { MaterialModule } from '../material/material.module';
import { CampanaVentaRoutingModule } from './campana-venta-routing.module';
import { BotonToggleModule } from '../boton/boton-toggle.module';
import { ListadoCamapanVentaComponent } from './listado-campana-venta/listado-campana-venta.component';
import { AccionesCampanaVentaModule } from './acciones-campana-venta/acciones-campana-venta.module';
import { FormsModule } from '@angular/forms';
import { LandingService } from '../../providers/landing.service';
import { CrearLandingModule } from './crear-landing/crear-landing.module';


@NgModule({
  declarations: [
    CampanaVentaComponent,
    ListadoCamapanVentaComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    MaterialModule,
    CampanaVentaRoutingModule,
    BotonToggleModule,
    AccionesCampanaVentaModule,
    CrearLandingModule
  ],

  entryComponents: [],
  providers: [LandingService]
})
export class CampanaVentaModule { }
